module.exports = {"TXTCLI_Number":{"id":"TXTCLI_Number","defaultMessage":"Nummer","track":"Number"}}